import { render, staticRenderFns } from "./deleteDialog.vue?vue&type=template&id=5ccfa78a"
import script from "./deleteDialog.vue?vue&type=script&lang=js"
export * from "./deleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports